// Vendors
import React from 'react';
// Styles
import {
  FinancialDataWrapperStyled,
  FinancialDataGroupContainerStyled,
} from './financial-data.component.styled';
// Hooks
import { useContractFinancialDataHook } from './hooks/financial-data.hook';
// Types
import { FinancialDataComponentType } from './types/financial-data.component.type';
// Utils
import { isLastItem, isMiddleItem } from './utils/financial-data.utils';
// Components
import { FinancialDataDetailComponent } from './components/detail/financial-data-detail.component';
import { FinancialDataTitle } from './components/title/financial-data-title.component';
import { FinancialDataPaymentMethodComponent } from './components/payment-method/financial-data-payment-method.component';
import { FinancialDataSeparator } from './components/separator/financial-data-separator.component';

const FinancialDataComponent = ({
  title,
  data,
  showTooltip,
  showLink,
}: FinancialDataComponentType): React.JSX.Element | null => {
  const { handleCloseIbanSelector, handleSaveChangedIban, showIbanSelector, setShowIbanSelector } =
    useContractFinancialDataHook();
  const length = data?.length;
  return (
    <FinancialDataWrapperStyled>
      <FinancialDataTitle {...{ title }} />
      <FinancialDataGroupContainerStyled>
        <>
          {data?.map((detail, index) =>
            !isLastItem({ index, length }) ? (
              <React.Fragment key={detail.label}>
                {isMiddleItem({ index, length }) && <FinancialDataSeparator />}
                <FinancialDataDetailComponent key={detail.label} {...{ detail }} />
              </React.Fragment>
            ) : (
              <FinancialDataPaymentMethodComponent
                key={detail.label}
                {...{
                  detail,
                  handleCloseIbanSelector,
                  handleSaveChangedIban,
                  showTooltip,
                  showLink,
                  setShowIbanSelector,
                  showIbanSelector,
                }}
              />
            )
          )}
        </>
      </FinancialDataGroupContainerStyled>
    </FinancialDataWrapperStyled>
  );
};

export { FinancialDataComponent };
